import { createContentHook } from './createContentHook';
import type { AboutSustainabilityContent } from '../types/AboutSustainabilityContent';

export const useAboutSustainabilityContent =
    createContentHook<AboutSustainabilityContent>('/About/Sustainability');
